import { Button, type ButtonProps } from '@mui/material';
import withPermission from './withPermission';

type AppButtonProps = {
  permission: string;
  module: string;
} & ButtonProps;

const AppButton = ({ module, permission, ...props }: AppButtonProps) => {
  return withPermission(Button, module, permission, false)(props);
};

export default AppButton;
